const Initialarray = {
    statuslogin:'fail',
    Name: "",
    UserID: "",
    CompanyID:"",
    TemplateID:"",
}

export default function Authentication(state = Initialarray, action) {
    switch (action.type) {
        case "Set_status":
            state = {
                ...state,
                statuslogin: action.status
            }
            break;
        case "SET_NAME":
            state = {
                ...state,
                Name: action.Name
            }
            break;
        case "Set_userid":
            state = {
                ...state,
                UserID: action.UserID
            }
            break;
        case "Set_companyid":
            state = {
                ...state,
                CompanyID: action.CompanyID
            }
            break;
        case "Set_templateid":
            state = {
                ...state,
                TemplateID: action.TemplateID
            }
            break; 
        case "Sign_Out_Authen":
            state = {
                state: null
            }
            break;
        case "SET_AUTHENTICATION":
            state = {
                ...state,
                statuslogin: "",
                Name: "",
                UserID: "",
                CompanyID: "",
                TemplateID: "",
            }
        default:

            break;
    }
    return state;
}